import React from "react";

const ProgressBar = (props) => {
    const percent = Math.round((100 * props.count) / props.maxCount);
    return (
        <div className="progress w-100">
            <div className="progress-bar" role="progressbar" style={{ width: `${percent}%` }}>
                {props.title} {props.count} ({percent}%)
            </div>
        </div>
    );
};

export { default as RequestsCount } from "./requestsCount";
export { default as RequestsDuration } from "./requestsDuration";
export { default as RequestsRate } from "./requestsRate";
export { default as RequestsSize } from "./requestsSize";
export { ProgressBar };
